<div class="banner d-lg-flex d-none">
  <h1>{{ 'marketplace.page.title' | translate }}</h1>
</div>

<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-3">
  <fgbcl-marketplace-list
    [isList]="true"
    [showSortBar]="false"
    [marketplaceItemTypes]="[0, 1, 2]"
    [defaultSort]="2"
  ></fgbcl-marketplace-list>
</div>
